module.exports = __webpack_public_path__ + "img/slovenia.949daeb.webp";